"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WireType = /** @class */ (function () {
    function WireType() {
    }
    WireType.TYPE_VARINT = 0;
    WireType.TYPE_FIXED64 = 1;
    WireType.TYPE_LENGTH_DELIMITED = 2;
    WireType.TYPE_START_GROUP = 3;
    WireType.TYPE_END_GROUP = 4;
    WireType.TYPE_FIXED32 = 5;
    WireType.MAX_TYPE = 6;
    return WireType;
}());
exports.default = WireType;
